<template>
	<main>
        
		<header id="main-header">
			<div class="container align-items-center">
                <Logo outerClass="flex-grow-1 text-lg-center" innerClass="logo" type="png" />
				<nav class="ml-auto">
					<ul class="justify-content-end">
						<li><a href="#why-choose-us" title="Why Choose Us?" v-scroll-to="'#why-choose-us'">Why Choose Us</a></li>
						<li><a href="#how-it-works" title="How it Works?" v-scroll-to="'#how-it-works'">How it Works</a></li>
                        <li><router-link to="/registration/1">Get Started</router-link></li>
					</ul>
				</nav>
			</div>
		</header>
		<section id="hero">
			<div id="hero-solid" class="d-flex align-items-center justify-content-center">
				<div>
                   
					<h1 class="uc grad-text mb-4">Personal Loan Funding, Simple and Easy.</h1>
					<h2 class="uc mb-4">Borrow up to $15,000, available as soon as tomorrow</h2>
					<ul class="tick-list mb-4">
						<li>Fast Real Time Results</li>
						<li>All Credit Types Accepted</li>
						<li>Safe and Secure</li>
					</ul>
					<HomeLeadFormButton />
				</div>
			</div>
			<div id="hero-photo">
			</div>
		</section>

		<WhyChoose />

		<HowItWorks />

		<FooterCTA />

		<Footer />

		<Disclaimers />
		
		<HomeLeadForm :show="this.allSettings.showLeadForm" />
		<div class="cover" v-if="this.allSettings.showLeadForm"></div>

        <HomeLoginForm v-if="auth.useragentRecognised || auth.recognisedEmail" :name="auth.userDetails.name" />

	</main>
</template>

<script>
// @ is an alias to /src
import HomeLoginForm from '@/components/home/HomeLoginForm.vue';
import HomeLeadForm from '@/components/home/HomeLeadForm.vue';
import HomeLeadFormButton from '@/components/home/HomeLeadFormButton.vue';
import WhyChoose from '@/components/home/WhyChoose.vue';
import HowItWorks from '@/components/home/HowItWorks.vue';
import FooterCTA from '@/components/home/FooterCTA.vue';
import Footer from '@/components/Footer.vue';
import Disclaimers from '@/components/home/Disclaimers.vue';
import Logo from '@/components/Logo.vue';

import { mapGetters, mapActions } from "vuex";

export default {
  name: 'home',
  title: 'CornerFin - As Heard on the Radio',
  components: {
    HomeLoginForm,
    HomeLeadForm,
    HomeLeadFormButton,
	WhyChoose,
	HowItWorks,
	FooterCTA,
	Footer,
    Disclaimers,
    Logo
  },
  methods: {
	...mapActions(["toggleLeadForm", "saveSplitTestData"]),
  },
  computed: mapGetters(["allSettings", "auth"]),
  created(){
      this.saveSplitTestData({
        "frontendType": "v1"
      });
  }
}
</script>

